<template>
  <div class="container" v-if="anchors && anchors.length > 0">
    <a class="anchors-list-item" :href="anchor.link" v-for="anchor in anchors" :key="anchor.id">{{ anchor.name }}</a>
  </div>
</template>

<script>
export default {
  name: 'shop-anchors',

  components: {},

  props: {
    anchors: Array,
  },

  data() {
    return {};
  },

  methods: {}
}
</script>

<style scoped>
.container {
  column-count: 5;
  margin-top: 20px;
  padding: 35px;
  color: #868993;
  background-color: #ffffff;
  border-radius: 3px;
}

.anchors-list-item {
  display: block;
  margin: 0 0 15px;
}

.anchors-list-item:hover {
  color: #3c91e6;
}

.anchors-list-item:active {
  color: #29629c;
}

@media (max-width: 768px) {
  .container {
    column-count: 2;
  }
}
</style>